var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C3.57604 0 0 3.57604 0 8C0 12.424 3.57604 16 8 16C12.424 16 16 12.424 16 8C16 3.57604 12.424 0 8 0V0ZM11.871 6.34101L7.13364 11.0599C6.98616 11.2074 6.80191 11.2811 6.61751 11.2811C6.43311 11.2811 6.23035 11.2074 6.10138 11.0599L3.76034 8.73726C3.46538 8.4423 3.46538 7.98147 3.76034 7.68651C4.0553 7.39154 4.51613 7.39154 4.81109 7.68651L6.61751 9.49292L10.8203 5.29016C11.1152 4.9952 11.5761 4.9952 11.871 5.29016C12.1475 5.58525 12.1475 6.06445 11.871 6.34105L11.871 6.34101Z",
    fill: "#2ECC71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolid);
export default __webpack_public_path__ + "static/media/check-circle-solid.4f02f1d5c31fa711475bd0cf550ab514.svg";
export { ForwardRef as ReactComponent };